var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0004 12.1018C11.0046 14.2018 5.91377 9.15676 7.9171 7.04843C9.14043 5.76093 7.75877 4.29009 6.99377 3.20759C5.55793 1.17843 2.4071 3.98009 2.5021 5.76259C2.8046 11.3843 8.88544 18.0459 14.7738 17.4643C16.6154 17.2826 18.7321 13.9559 16.6196 12.7401C15.5629 12.1318 14.1121 10.9318 13.0004 12.1009",
    stroke: "#FE5A97",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPhone);
export default __webpack_public_path__ + "static/media/footerPhone.aaf50cc31444cf40344c68e68f4a1d07.svg";
export { ForwardRef as ReactComponent };